import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TIPO_CAUSALE, TipoCausale} from "../../../_helpers/TipoCausale";

@Component({
    selector: 'app-select-causale-tipo',
    templateUrl: './select-causale-tipo.component.html',
    styleUrls: ['./select-causale-tipo.component.scss'],
    standalone: false
})
export class SelectCausaleTipoComponent {
  @Input() tipoCausale: TipoCausale;
  @Output() tipoCausaleChange = new EventEmitter<TipoCausale>();
  tipoCausalesItem = TIPO_CAUSALE;
  selectTipoCausale = (e: SelectCustomEvent) => this.tipoCausaleChange.emit(+e.target.value);
}
